import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Form } from "reactstrap";
import SelectComponent from "../../../utils/SelectComponent/SelectComponent";
import { Formik } from "formik";
import * as yup from "yup";
import _ from "lodash";
import useAsync from "react-use-async-hook";

import * as ProfileAPI from "../../../../api/profile";
import { useSetLoading } from "../../../utils/hooks/loader";
import addNotification from "../../../utils/notification/notification";

const ProfileDetailsSetup = ({ setup, userInfo, refreshUserDetail }) => {
    const [initialValues, setInitialValue] = useState({
        prefix: "",
        firstName: "",
        middleName: "",
        lastName: "",
    });

    useEffect(() => {
        if (userInfo) {
            setInitialValue({
                prefix: _.get(userInfo, "title")
                    ? {
                          value: _.get(userInfo, "title"),
                          label: _.get(userInfo, "title"),
                      }
                    : "",
                firstName: userInfo.firstName || "",
                middleName: userInfo.middleName || "",
                lastName: userInfo.lastName || "",
            });
        }
    }, [userInfo]);

    /**
     * Update Profile
     */
    const { loading: updateProfileLoader, execute: executeUpdateProfile } =
        useAsync({
            autoExecute: false,
            task: useCallback(async (payload, formikBag) => {
                return {
                    res: await ProfileAPI.setProfile(payload),
                    formikBag,
                };
            }, []),
            dataLoader: useCallback(({ res, formikBag }) => {
                formikBag.setSubmitting(false);
                refreshUserDetail();
                addNotification({
                    type: "success",
                    title: "Success",
                    message: _.get(res, "data.message", "Success"),
                });
            }, []),
            onError: useCallback(error => {
                addNotification({
                    type: "danger",
                    title: "Error",
                    message: _.get(
                        error,
                        "response.data.message",
                        "Oops! something went wrong..."
                    ),
                });
            }, []),
        });

    const showLoader = useMemo(
        () => updateProfileLoader,
        [updateProfileLoader]
    );
    useSetLoading(showLoader);

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={yup.object({
                firstName: yup.string().required("First Name is required"),
                middleName: yup.string().nullable(),
                lastName: yup.string().required("Last Name is required"),
            })}
            onSubmit={(values, formikBag) => {
                executeUpdateProfile(
                    {
                        title: values.prefix.value,
                        firstName: values.firstName,
                        lastName: values.lastName,
                        middleName: values.middleName,
                    },
                    formikBag
                );
            }}
        >
            {({
                values,
                errors,
                touched,
                handleSubmit,
                setFieldValue,
                setSubmitting,
                handleBlur,
                isSubmitting,
            }) => {
                const handleChange = e => {
                    const { name, value } = e.target;
                    setFieldValue(name, value);
                    setSubmitting(false);
                };
                return (
                    <Form
                        className='profileDetailsSetup-form'
                        onSubmit={handleSubmit}
                    >
                        <div className='cardbox-wrapper'>
                            <div className='cardbox-heading'>
                                <h4 className='cardbox-heading-name text-capitalize text-black'>
                                    Personal Details Setup
                                </h4>
                            </div>
                            <div className='inputcard-wrapper cardbox-body'>
                                <div className='inputcard-body custom-inputcard-body'>
                                    <div className='inputcard-group two-cardbox d-flex align-items-center justify-content-start'>
                                        <div className='choose-reason inputfield d-flex align-items-center justify-content-between'>
                                            <div className='inputcard-withlabel d-flex align-items-start justify-content-center flex-column '>
                                                <label className='inputcard-label'>
                                                    Prefix
                                                </label>
                                                <SelectComponent
                                                    placeholder='Select'
                                                    options={[
                                                        {
                                                            value: "Mr",
                                                            label: "Mr",
                                                        },
                                                        {
                                                            value: "Mrs",
                                                            label: "Mrs",
                                                        },
                                                        {
                                                            value: "Ms",
                                                            label: "Ms",
                                                        },
                                                    ]}
                                                    defaultValue={values.prefix}
                                                    selectedOption={
                                                        values.prefix
                                                    }
                                                    name='prefix'
                                                    handleChange={e => {
                                                        setFieldValue(
                                                            "prefix",
                                                            e
                                                        );
                                                        setSubmitting(false);
                                                    }}
                                                    disabled={
                                                        !(
                                                            setup &&
                                                            !setup.personal
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className='choose-reason inputfield d-flex align-items-center justify-content-between'>
                                            <div className='inputcard-withlabel d-flex align-items-start justify-content-center flex-column'>
                                                <label className='inputcard-label'>
                                                    First Name
                                                    <small className='ml-2 input-mandatory'>
                                                        *
                                                    </small>
                                                </label>
                                                <input
                                                    id='firstName'
                                                    className='custominputfield'
                                                    type='text'
                                                    placeholder='Enter'
                                                    value={values.firstName}
                                                    name='firstName'
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={
                                                        !(
                                                            setup &&
                                                            !setup.personal
                                                        )
                                                    }
                                                />
                                                {errors.firstName &&
                                                touched.firstName ? (
                                                    <span className='error-input-msg mt-md-3'>
                                                        {errors.firstName}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='inputcard-group two-cardbox d-flex align-items-center justify-content-start'>
                                        <div className='choose-reason inputfield d-flex align-items-center justify-content-between'>
                                            <div className='inputcard-withlabel d-flex align-items-start justify-content-center flex-column'>
                                                <label className='inputcard-label'>
                                                    Middle Name
                                                </label>
                                                <input
                                                    id='middleName'
                                                    className='custominputfield'
                                                    type='text'
                                                    value={values.middleName}
                                                    placeholder='Enter'
                                                    name='middleName'
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={
                                                        !(
                                                            setup &&
                                                            !setup.personal
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className='choose-reason inputfield d-flex align-items-center justify-content-between'>
                                            <div className='inputcard-withlabel d-flex align-items-start justify-content-center flex-column'>
                                                <label className='inputcard-label'>
                                                    Last Name
                                                    <small className='ml-2 input-mandatory'>
                                                        *
                                                    </small>
                                                </label>
                                                <input
                                                    id='lastName'
                                                    className='custominputfield'
                                                    type='text'
                                                    value={values.lastName}
                                                    placeholder='Enter'
                                                    name='lastName'
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={
                                                        !(
                                                            setup &&
                                                            !setup.personal
                                                        )
                                                    }
                                                />
                                                {errors.lastName &&
                                                touched.lastName ? (
                                                    <span className='error-input-msg mt-md-3'>
                                                        {errors.lastName}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='inputcard-footer'>
                                    {setup && !setup.personal && (
                                        <button
                                            type='submit'
                                            disabled={isSubmitting}
                                            className='btn-theme btn-search-wrapper'
                                        >
                                            Confirm Details
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default ProfileDetailsSetup;
